import React, { useEffect, useRef, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import MarketData from './MarketData/MarketData';
import SimilarJobPostings from './SimilarJobPostings/SimilarJobPosting';
import CreateJob from './CreateJob/CreateJob';
import { useParams, useNavigate } from 'react-router-dom';
import APIBaseURL from '../../../../AppConfig/AppConfig.json'
import axios from 'axios';
import { getMarketetJobData, getUptoDateMarketJobData } from '../jobManagemnetApi';
import { useSnackbar } from '../../../../Context/SnackbarContext';
import { theme } from '../../../../theme';


interface marketSalaryDataType {
    MarketDataNum: number | null,
    JobNum: number | null,
    JobTitle: string | null,
    MaximumSalary: number | null,
    MedianSalary: number | null,
    MinimumSalary: number | null
}

export interface similarJobsDataType {
    CompanyName: string | null,
    JobTitle: string | null,
    Region: string | null,
    SimilarJobNum: number | null,
    JobLink: string,
    CreatedDate: string
}
const CreateJobPosting: React.FC = () => {
    const [jobNum, setJobNum] = useState<number>()
    const [readOnly, setReadOnly] = useState(false)
    const [marketJobTitle, setMarketJobTitle] = useState<string>('')
    const [marketSalaryData, setMarketSalaryData] = useState<marketSalaryDataType | null>(null)
    const [similarJobsData, setSimilarJobsData] = useState<similarJobsDataType[]>([])
    const [jobLocation, setJobLocation] = useState('')
    const { showSnackbar } = useSnackbar();

    const { tenant } = useParams<{ tenant: string }>();
    const [loading, setLoading] = useState(false)

    const fetchCountRef = useRef(0); // Track how many times the function is called   

    const fetchMarketJobData = async (jobNum: number) => {
        const result = await getMarketetJobData(tenant, jobNum)
        if (result) {
            setMarketSalaryData(result.market_salary_data || null)
        }
    }

    useEffect(() => {
        if (jobNum) {
            fetchMarketJobData(jobNum)
        }
    }, [jobNum])

    useEffect(() => {
        const interval = setInterval(() => {
            // Only call if data is empty AND fetch count is less than 4
            if (!marketSalaryData && fetchCountRef.current < 4) {
                if (jobNum) {
                    fetchMarketJobData(jobNum);
                    fetchCountRef.current += 1; // Increase count
                }
            } else {
                clearInterval(interval); // Stop calling if data exists or 4 attempts have been made
            }
        }, 60000); // Every 1 minute

        return () => clearInterval(interval); // Cleanup on unmount
    }, [jobNum, marketSalaryData]); // Dependencies updated


    const handleUptoDateMarketData = async () => {
        if (jobNum) {

            setLoading(true)
            try {
                const payLoad = {
                    "JobNum": jobNum,
                    "JobTitle": marketJobTitle,
                    "Location": jobLocation
                }
                const result = await getUptoDateMarketJobData(tenant, payLoad)
                if (result) {
                    setMarketSalaryData(result.market_salary_data || null)
                    showSnackbar('Market data imported successfully!', 'success')
                }else{
                    showSnackbar("Oops! We couldn't fetch the latest market data right now. Please try again in a moment.","error")
                }
            } catch (error) {
                setLoading(false)
                showSnackbar('Something went wrong while generating the salary data.Please try again', 'error')
                console.error('Error fetching upto date market job data:', error)
                
            } finally {
                setLoading(false)
            }
        }

    }
    return (
        <Box
            sx={{

                boxSizing: 'border-box', // Ensure padding does not affect width
                display: 'flex',
                flexDirection: 'column',
                gap: 1,

                marginLeft: '2.3vw',
                marginRight: '1.3vw',

            }}
        >
            <Box >
                <CreateJob setJobNum={setJobNum} setMarketJobTitle={setMarketJobTitle} setReadOnly={setReadOnly} setJobLocation={setJobLocation} />
            </Box>

            {/* {jobNum?(marketSalaryData || similarJobsData.length>0)?<></>:<Box sx={{display:'flex',justifyContent:'center'}}><Typography variant='subtitle1' sx={{display:'flex',justifyContent:'center',alignItems:'center',border:'1px solid #E0E0E0',px:'1vw',py:'0.5vw',gap:1,borderRadius:'0.5vw'}}><CircularProgress size={30} disableShrink/>Market data is fetching</Typography></Box>:<></>} */}

            <Box >
                {(readOnly && jobNum) ? (<MarketData
                    marketSalaryData={marketSalaryData}
                    handleUptoDateMarketData={handleUptoDateMarketData}
                    loading={loading}
                    marketJobTitle={marketJobTitle}
                    readOnly={readOnly} />) : (<></>)}
            </Box>
            {/* <Box>
                {(readOnly && jobNum)?(<SimilarJobPostings 
                similarJobsData={similarJobsData} 
                />):(<></>)}
            </Box> */}

            <Box>
                {(readOnly && jobNum && marketJobTitle && jobLocation) ? (
                    <Box mt={1} px={2} py={2} mb={1} sx={{ backgroundColor: theme.palette.primary.light, borderRadius: '8px' }}>
                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                            Explore Similar Jobs Online
                        </Typography>
                        <Typography variant="body2" sx={{ mb: 1.5 }}>
                            Want to see more opportunities for <strong>{marketJobTitle}</strong> roles in <strong>{jobLocation}</strong>?
                            You can explore listings from popular job sites and discover what’s currently open.
                        </Typography>
                        <Box>
                            <a
                                href={`https://www.google.com/search?q=${encodeURIComponent(`${marketJobTitle} jobs in ${jobLocation} openings`)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    fontSize: '0.95rem',
                                    color: theme.palette.primary.main,
                                    fontWeight: 500,
                                    textDecoration: 'none',
                                    border: `1px solid ${theme.palette.primary.main}`,
                                    borderRadius: '6px',
                                    padding: '0.5rem 1rem',
                                    display: 'inline-block',
                                    transition: 'all 0.3s',
                                }}
                                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#e3f2fd')}
                                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                            >
                                Search Jobs on Google
                            </a>
                        </Box>
                    </Box>
                ) : null}
            </Box>



        </Box>
    );
};

export default CreateJobPosting;
